import axiosInstance from './AxiosInstance';

export const getLatestProperties = async () => {
  const response = await axiosInstance.get('/graph/latest-properties');
  return response.data;
};
